import { Form } from "react-bootstrap";
import { Release } from "../../models";
import { SEMVER_PATTERN_FULL } from "../../utils";
import { VersionField } from "./VersionField";

interface Props {
  enabled: boolean;
  onEnabledChange: (enabled: boolean) => void;
  bundleReleases: Release[];
  requiredBundleVersion: string | undefined;
  onRequiredBundleVersionChange: (value: string) => void;
  requiredTokenAppVersion: string | undefined;
  onRequiredTokenAppVersionChange: (value: string) => void;
  requiredTmatAppVersion: string | undefined;
  onRequiredTmatAppVersionChange: (value: string) => void;
}

export function RequirementsSection({
  enabled,
  onEnabledChange,
  bundleReleases,
  requiredBundleVersion,
  onRequiredBundleVersionChange,
  requiredTokenAppVersion,
  onRequiredTokenAppVersionChange,
  requiredTmatAppVersion,
  onRequiredTmatAppVersionChange,
}: Props) {
  return (
    <>
      <Form.Group controlId="requirementsEnabled" className="mb-3">
        <Form.Check
          type="checkbox"
          label="Requirements"
          checked={enabled}
          onChange={(e) => onEnabledChange(e.target.checked)}
        />
      </Form.Group>

      {enabled && (
        <div className="ms-4 mb-3">
          <Form.Group controlId="requiredBundleVersion" className="mb-3">
            <Form.Label>Bundle Version</Form.Label>
            <Form.Select
              size="sm"
              value={requiredBundleVersion ?? ""}
              onChange={(e) => onRequiredBundleVersionChange(e.target.value)}
            >
              <option value="">-- select release --</option>
              {bundleReleases.map((release) => (
                <option key={`bundle-version-${release.version}`} value={release.version}>
                  {release.version}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <VersionField
            controlId="requiredTokenAppVersion"
            label="Token App Version"
            placeholder="e.g. 1.2.3"
            value={requiredTokenAppVersion}
            onChange={onRequiredTokenAppVersionChange}
            pattern={SEMVER_PATTERN_FULL}
            invalidMessage="Must be a semantic version (e.g. 1.2.3)."
            required={false}
            className="mb-3"
          />

          <VersionField
            controlId="requiredTmatAppVersion"
            label="TMAT App Version"
            placeholder="e.g. 1.2.3"
            value={requiredTmatAppVersion}
            onChange={onRequiredTmatAppVersionChange}
            pattern={SEMVER_PATTERN_FULL}
            invalidMessage="Must be a semantic version (e.g. 1.2.3)."
            required={false}
            className="mb-3"
          />
        </div>
      )}
    </>
  );
}
